import styles from './channel-bar-menu.module.scss';
import * as React from 'react';
import { WMenu } from '../../wrappers/wrapper';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import Button from 'components/atoms/button/button';
import { useState } from 'react';
import useDeviceType from 'custom-hooks/useDeviceType';
import { Divider } from '@mui/material';
import SpaceMembers from 'components/molecules/space-members/space-members';
import { IPaginate, TSpace } from 'models/common';
import LeaveSpace from 'components/molecules/leave-space/leave-space';
import MobileModal from 'components/molecules/mobile-modal/mobile-modal';

interface ChannelBarMenuProps {
  spaces: IPaginate<TSpace> | null;
  onLeaveSpace: () => void;
  onClickMembers: () => void;
}
const ChannelBarMenu: React.FC<ChannelBarMenuProps> = ({
  spaces,
  onClickMembers,
  onLeaveSpace,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);

  const openPopover = Boolean(anchorEl);

  const { isDesktop } = useDeviceType();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (isDesktop) {
      setAnchorEl(event.currentTarget);
      return;
    }

    setOpenSettingsModal(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickItem = (value: 'leave_space') => {
    switch (value) {
      case 'leave_space':
        onLeaveSpace();
        break;
      default:
        return;
    }
  };

  const handleCloseSettingsModal = () => {
    setOpenSettingsModal(false);
  };

  return (
    <>
      <Button type="base" onClick={handleClick} className={styles.more}>
        <MoreHoriz style={{color:"var(--color-white)"}} />
      </Button>
      <WMenu
        anchorEl={anchorEl}
        open={openPopover}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              border: 'var(--border)',
              padding: '1rem',
              width: '14rem',
              borderRadius: 'var(--border-radius)',
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        className={styles.menu}
      >
        <LeaveSpace onClick={() => handleClickItem('leave_space')} />
      </WMenu>

      <MobileModal
        title="Space settings"
        open={openSettingsModal}
        onClose={handleCloseSettingsModal}
      >
        <div className={styles.modalContent}>
          <div className={styles.section}>
            <span>Members</span>
            <SpaceMembers
              totalCount={spaces?.meta?.total!}
              data={spaces?.data!}
              onClick={onClickMembers}
              className={styles.members}
            />
          </div>
          <Divider />
          <LeaveSpace onClick={() => handleClickItem('leave_space')} />
        </div>
      </MobileModal>
    </>
  );
};
export default ChannelBarMenu;
